import React, { useState } from 'react'
import 'styles/app/apps/jobs-triggers.scss'
import JobsTriggersHeader from './JobsTriggersHeader'
import JobsTriggersTable from './JobsTriggersTable'
import AddTriggerMenu from './AddTriggerMenu'
import { StyledJobsTriggers } from './styles'

function JobsTriggers() {
  const [isAddTriggerModalOpened, setIsAddTriggerModalOpened] = useState(false)
  const [activeRuleId, setActiveRuleId] = useState(null)

  return (
    <StyledJobsTriggers direction="column">
      <JobsTriggersHeader setIsModalOpened={setIsAddTriggerModalOpened} />
      <JobsTriggersTable
        setIsModalOpened={setIsAddTriggerModalOpened}
        setActiveRuleId={setActiveRuleId}
      />
      <AddTriggerMenu
        isModalOpened={isAddTriggerModalOpened}
        setIsModalOpened={setIsAddTriggerModalOpened}
        activeRuleId={activeRuleId}
        setActiveRuleId={setActiveRuleId}
      />
    </StyledJobsTriggers>
  )
}

export default JobsTriggers
